export default __webpack_public_path__ + "static/media/standsExpo_schneider.7775684d.jpg";